import { Link } from 'react-router-dom';
import './TermsOfService.css';

function TermsOfService() {
  return (
    <div className="TermsOfService">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <Link to="/" className="logo-link">
            <div className="logo">
              <img src="/app-icon.png" alt="Orbit Rings Logo" className="logo-icon" />
              <span className="logo-text">Orbit Rings</span>
            </div>
          </Link>
          <div className="nav-links">
            <Link to="/">Home</Link>
          </div>
        </div>
      </nav>

      {/* Terms Section */}
      <section className="terms-section">
        <div className="terms-container">
          <div className="terms-content">
            <p className="terms-text">This app is offered by:</p>

            <div className="provider-info">
              <p>Sirak Zeray</p>
              <p>Email: <a href="mailto:Sirakzeray@gmail.com" className="email-link">Sirakzeray@gmail.com</a></p>
            </div>

            <p className="terms-text">
              For Legal Queries and Actions Reach Out to - <a href="mailto:sirakzeray@gmail.com" className="email-link">sirakzeray@gmail.com</a>
            </p>

            <p className="terms-text last-updated">Last updated November 16, 2025</p>

            <a
              href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
              target="_blank"
              rel="noopener noreferrer"
              className="eula-link"
            >
              Licensed Application End User License Agreement
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TermsOfService;
